import { useAppSelector } from '@/redux/store';
import { OrganizationUserRoleSlugs } from '@/types/users';

export const useIsSuperAdmin = () =>
  useAppSelector(
    state =>
      state.loggedUser?.organizationUserRoles?.some(
        role => role.slug === OrganizationUserRoleSlugs.SUPER_ADMIN
      ) ?? false
  );
